export default {"src":"/_next/static/image/public/images/ic_next_rounded.8c4d2ce3edecc5e79be67c05b9869388.svg","height":28,"width":27};